module.exports = "/packs/011-437a0f465fc79491d7cf53f1d32a47b8.jpg";